
import { defineComponent, ref, computed, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStarTheme, useStarRouter } from '@/utils/useStarTheme'
import { useStarUserPermission } from '@/utils/useStarUserPermission'
import MessagePanel from '@/views/star/message.vue'
import StarUserProfile from '@/components/star/StarUserProfile.vue'

export const STAR_TABS = [
  { key: 'home', label: '首页', path: '/star' },
  { key: 'zone', label: '量化专区', path: '/star/zone' },
  { key: 'square', label: '模版策略', path: '/star/square' },
  { key: 'hotSubject', label: '热门专题', path: '/star/hot-subject' },
  { key: 'school', label: '投资学院', path: '/allcourse' },
] as const

export function resolveStarTabKey(path: string, query: Record<string, any> = {}): string {
  if (path.startsWith('/star/zone')) return 'zone'
  if (path.startsWith('/star/square')) return 'square'
  if (path.startsWith('/star/hot-subject')) return 'hotSubject'
  if (path.startsWith('/star/quant')) return 'quant'
  if (path.startsWith('/allcourse') || query.starEmbed === '1') return 'school'
  return 'home'
}

export default defineComponent({
  name: 'StarTabBar',
  components: { MessagePanel, StarUserProfile },
  props: {
    modelValue: { type: String, default: '' }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const route = useRoute()
    const { isLight } = useStarTheme()
    const { starPush } = useStarRouter()
    const { refreshPermission } = useStarUserPermission()
    const showMessage = ref(false)

    onMounted(() => {
      void refreshPermission()
    })

    const activeTab = computed(() => {
      if (props.modelValue) return props.modelValue
      return resolveStarTabKey(route.path, route.query as Record<string, any>)
    })

    const tabs = STAR_TABS

    watch(
      () => route.path,
      () => {
        const key = resolveStarTabKey(route.path, route.query as Record<string, any>)
        emit('update:modelValue', key)
      },
      { immediate: true }
    )

    const handleClick = (tab: { key: string; label: string; path: string }) => {
      emit('update:modelValue', tab.key)
      const extraQuery: Record<string, string> =
        tab.key === 'school' ? { from: 'star', starEmbed: '1' } : {}
      if (tab.key === 'home') {
        starPush('/star', extraQuery)
      } else {
        starPush(tab.path, extraQuery)
      }
    }

    return { tabs, activeTab, isLight, handleClick, showMessage }
  }
})
